import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import { Row, Col } from "react-bootstrap";
import { AnimatePresence,motion } from 'framer-motion';
import '../lib/bootstrap.min.css'
import '../lib/css/shonir_analog_clock.css'
import './Main.css';
import './SubPage.css';

const ClockWidget = forwardRef((props,refParent) => {
    const ref = useRef(null);
    const [_timer,_setTimer] = useState('ok')
    var timer = true
    function int_shonir_analog_clock(id, time_zone, label) {
        var clockEl = document.getElementById(id);
        var dialLines = document.getElementById(id).getElementsByClassName('diallines');
        
        for (var i = 1; i < 60; i++) {
          clockEl.innerHTML += "<div class='diallines'></div>";
          dialLines[i].style.transform = "rotate(" + 6 * i + "deg)";
        }
        
        setInterval(function () {
            if(timer === true ){
                shonir_analog_clock(id, time_zone, label);
            }
        }, 100);
        
    }
        
    function shonir_analog_clock(id, time_zone, label) {
        var clockEl = document.getElementById(id);
    
        if(time_zone){ 
            var sys_date = new Date().toLocaleString("en-US", { timeZone: time_zone });;
            var d = new Date(sys_date);
        }else{
            d = new Date();
        }
    
        const _month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        const _day = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
        var h = d.getHours(),
            m = d.getMinutes(),
            s = d.getSeconds(),
            day = d.getDay(),
            date = d.getDate(),
            month = _month[d.getMonth()],
            year = d.getFullYear(),
                    
          hDeg = h * 30 + m * (360/720),
          mDeg = m * 6 + s * (360/3600),
          sDeg = s * 6,
          
          hEl = clockEl.querySelector('.hour-hand'),
          mEl = clockEl.querySelector('.minute-hand'),
          sEl = clockEl.querySelector('.second-hand'),
          dateEl = clockEl.querySelector('.date'),
          timeEl = clockEl.querySelector('.time');
          clockEl.style.backgroundColor = "rgba(20, 15, 0, 0.7)";

      if(month < 9) {
        month = "0" + month;
      }
      if(h < 10) {
        h = "0" + h;
      }
      if(m < 10) {
        m = "0" + m;
      }
      

      hEl.style.transform = "rotate("+hDeg+"deg)";
      mEl.style.transform = "rotate("+mDeg+"deg)";
      sEl.style.transform = "rotate("+sDeg+"deg)";
      dateEl.innerHTML = label + "<br />" + date+" / "+month+" / "+year;
      timeEl.innerHTML =  _day[day] + ', '+h+':'+m;
    }
    useImperativeHandle(refParent, () => ({
        exitPage: () => {
            timer=false
        }
    }));
    useEffect(() => {
        console.log(props.content)
        for(var i =0; i < props.content.length; i++){  
            int_shonir_analog_clock(
                props.content[i].id,
                props.content[i].timezone,
                props.content[i].title
            )
        }
    }, []);

    return (
    <AnimatePresence>
        <Row>
            <Col md={12}>
                <motion.div 
                    ref={ref}
                    className='content-subpage'
                    style={{height:(props.height)+'px',backgroundColor:'rgba(50, 15, 0, 0.6)'}}
                    initial={{ opacity: 0, marginTop:-50 }}
                    animate={{ opacity: 1, marginTop: 0,  }}
                    exit={{opacity:0, marginTop:300}}
                    transition={{ duration: 1.2, ease: [0.87, 0, 0.13, 1] }}
                >
                    <h2>World Clock</h2>
                    <table style={{width:'100%'}} className='wclock'>
                        <tr>
                            {props.content.map((timezone,key)=>(
                                <td key={key}>
                                    <div id={timezone.id} className="analog_clock d-flex justify-content-center">
                                        <div>
                                            <div className="date"></div>
                                            <div className="info time"></div>
                                        </div>
                                        <div className="dot"></div>
                                        <div>
                                            <div className="hour-hand"></div>
                                            <div className="minute-hand"></div>
                                            <div className="second-hand"></div>
                                        </div>
                                        <div>
                                            <span className="h_3">3</span>
                                            <span className="h_6">6</span>
                                            <span className="h_9">9</span>
                                            <span className="h_12">12</span>
                                        </div>
                                        <div className="diallines"></div>
                                    </div>
                                </td>
                            ))}
                           
                        </tr>
                        
                    </table>
                    
                </motion.div>
            </Col>
        </Row>
    </AnimatePresence>
  )});

export default ClockWidget;


